const routes = {
    '/Dashboard_Members/index': () => import('./modules/index.js'),
    '/Dashboard_Members/login': () => import('./modules/login.js'),
    '/Dashboard_Members/register': () => import('./modules/register.js'),
    '/Dashboard_Members/404': () => import('./modules/404.js')
};

export class Router {
    constructor(containerId) {
        this.containerId = containerId;
        this.container = null;
        
        // Inicializar eventos
        this.init();
    }

    init() {
        window.addEventListener('popstate', () => this.handleRoute());

        document.addEventListener('click', (e) => {
            const link = e.target.closest('[data-link]');
            if (link) {
                e.preventDefault();
                this.navigateTo(link.getAttribute('href'));
            }
        });

        // Procesar la ruta inicial
        this.handleRoute();
    }

    navigateTo(url) {
        window.history.pushState(null, null, url);
        this.handleRoute();
    }

    async handleRoute() {
        let path = window.location.pathname;

        // Limpiamos la barra final si existe (ej: /Dashboard_Members/index/ -> /Dashboard_Members/index)
        if (path.endsWith('/') && path.length > 1) {
            path = path.slice(0, -1);
        }

        // 2. Buscamos en el nuevo mapa de rutas o disparamos el 404 de Members
        const loadModule = routes[path] || routes['/Dashboard_Members/404'];

        if (!loadModule) {
            console.error(`Ruta no definida y sin respaldo 404 de Miembros: ${path}`);
            return;
        }

        try {
            // 3. Importación dinámica del módulo de miembros
            const module = await loadModule();
            
            if (module.default) {
                // Buscamos el contenedor en el DOM
                this.container = document.getElementById(this.containerId);
                
                if (!this.container) {
                    // CASO A: Vistas nativas de PHP (Login/Register de Miembros)
                    console.log(`Ejecutando módulo directo en vista PHP de Miembros para: ${path}`);
                    module.default(null); 
                } else {
                    // CASO B: Zona SPA dinámica del panel de Miembros
                    this.container.innerHTML = ''; 
                    module.default(this.container);
                }
            }
        } catch (error) {
            console.error(`Error cargando la ruta de miembros ${path}:`, error);
            if (this.container) {
                this.container.innerHTML = `<p>Error al cargar el panel de miembros.</p>`;
            }
        }
    }
}